import React from 'react';

import * as ReviewLifecyclesDAO from 'notebook/reviews/review-lifecycles/ReviewLifecyclesDAO';
import {areReviewLifecyclesEnabledForUser} from 'notebook/reviews/review-lifecycles/ReviewLifecyclesUtil';
import getTestProps from 'test/lib/cypress/getTestProps';

import EmptySidebarIcon from './EmptySidebarIcon';
import {Section, SettingsSection} from './SidebarConstants';
import SidebarItem from './SidebarItem';

export interface NotebookSettingsProps {
  section: SettingsSection;
}

function ReviewLifecyclesSidebarItem({
  section,
}: {
  section: NotebookSettingsProps['section'];
}): JSX.Element | null {
  if (areReviewLifecyclesEnabledForUser()) {
    return (
      <SidebarItem
        active={section === Section.REVIEW_LIFECYCLES}
        icon={<EmptySidebarIcon />}
        name="Review processes"
        link={ReviewLifecyclesDAO.reviewLifecyclesListingURL()}
      />
    );
  }
  return null;
}

export default function NotebookSettings(props: NotebookSettingsProps): JSX.Element {
  return (
    <div className="u-spacing-top">
      <div
        {...getTestProps({component: 'NotebookSettings', element: 'header'})}
        className="browser-nav-header"
      >
        Review Settings
      </div>
      <ReviewLifecyclesSidebarItem section={props.section} />
    </div>
  );
}
